import React, {useEffect, useState} from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {Step4and5} from "../../../../components/misc/Headings.js";
import {useParams} from "react-router-dom";
import {query, collection, where, getDocs} from "firebase/firestore";
import {db} from "../../../../FireBaseConfig";

const HighlightedText = styled.span`
    ${tw`text-primary-500`};
    color: #0ABD19;
`;
const FormContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
`;


const StepTitle = styled(Step4and5)`
    ${tw`w-full mt-2 mb-6`};
`;


const StepRowContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 48px;
    padding-top: 30px;
    max-width: 1080px;
    margin: 0 auto;
    width: 100%;
`;


const StepContainer = styled.div`
    ${tw`p-8 bg-white shadow-lg rounded-lg border`};
    border: 2px solid #1BA557;
    border-radius: 15px;
    padding: 20px;
    height: 170px;
    text-align: center;
    width: 520px;
`;
const StepContainer5 = styled(StepContainer)`
    height: 115px;
`;

const StepText = styled.p`
    ${tw`text-base text-gray-600`};
    margin-top: 8px;
`;
const BoldGreenText = styled.h3`
    ${tw`font-bold text-lg`};
    color: #0ABD19;
`;

const Step4Container = styled.div`
    transform: translateX(-95px);
`;


const Step5Container = styled.div`
    transform: translateX(-38px);
`;
const Step4and5Step = ({onInsuranceUpdate}) => {
    const {id} = useParams();
    const [totalCostUSD, setTotalCostUSD] = useState(0); // Общая стоимость в долларах
    const [totalCostKZT, setTotalCostKZT] = useState(0); // Общая стоимость в тенге
    const [insuranceAmount, setInsuranceAmount] = useState(0); // Сумма страхования в тенге
    const [usdToKztRate, setUsdToKztRate] = useState(0); // Курс доллара к тенге
    const [buttonActive, setButtonActive] = useState(false); // Состояние кнопки
    const [customDutyEUR, setCustomDutyEUR] = useState(0); // Сумма таможенной пошлины в евро
    const [customDutyKZT, setCustomDutyKZT] = useState(0);
    const [usdToEurRate, setUsdToEurRate] = useState(0); // Курс доллара к евро
    const [customDuty, setCustomDuty] = useState(0); // Сумма таможенной пошлины
    // insuranceIncluded удалено - страхование теперь всегда обязательно
    const [customDutyUSD] = useState(3);
    const [eurToKztRate, setEurToKztRate] = useState(0);

    useEffect(() => {
        // Получаем курс доллара к тенге
        const fetchExchangeRate = async () => {
            try {
                const response = await fetch(
                    `https://openexchangerates.org/api/latest.json?app_id=dcdd8eb0771e4dffa7bdf44d9637fc6f`
                );
                const data = await response.json();
                const rate = data.rates.KZT; // Курс доллара к тенге
                setUsdToKztRate(rate);

                // Рассчитываем фиксированную пошлину в тенге
                setCustomDutyKZT(customDutyUSD * rate);
            } catch (error) {
                console.error('Error fetching exchange rate:', error);
            }
        };


        // Функция для получения данных о посылке
        const fetchParcelData = async (parcelId) => {
            const cleanId = parcelId.trim();

            try {
                const q = query(collection(db, "parcels"), where("id", "==", cleanId));
                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    querySnapshot.forEach((doc) => {
                        const parcelData = doc.data();
                        const products = parcelData.products || [];
                        const totalUSD = products.reduce(
                            (acc, product) => acc + parseFloat(product.productPrice),
                            0
                        );

                        const totalKZT = totalUSD * usdToKztRate;
                        const insurance = totalKZT * 0.015;


                        setTotalCostUSD(totalUSD);
                        setTotalCostKZT(totalKZT);
                        setInsuranceAmount(insurance);
                    });
                }
            } catch (error) {
                console.error('Error fetching parcel data:', error);
            }
        };

        if (id) {
            fetchExchangeRate();
            fetchParcelData(id);
        }
    }, [id, usdToKztRate]);
    // Страхование обязательно, поэтому всегда передаем insuranceIncluded: true
    useEffect(() => {
        if (customDutyKZT > 0 || insuranceAmount > 0) {
            onInsuranceUpdate({
                totalCostKZT: totalCostKZT,
                insuranceAmount: Math.round(insuranceAmount), // Передаём округлённую сумму страхования
                customDutyKZT: customDutyKZT,
                insuranceIncluded: true, // Страхование обязательно
            });
        }
    }, [customDutyKZT, totalCostKZT, insuranceAmount]);


    useEffect(() => {
        // Получаем курсы валют
        const fetchExchangeRates = async () => {
            try {
                const response = await fetch(
                    `https://openexchangerates.org/api/latest.json?app_id=dcdd8eb0771e4dffa7bdf44d9637fc6f`
                );
                const data = await response.json();
                setUsdToKztRate(data.rates.KZT); // Курс доллара к тенге
                setUsdToEurRate(data.rates.EUR);
                setEurToKztRate(data.rates.KZT / data.rates.EUR); // курс евро к тенге
// Курс доллара к евро
            } catch (error) {
                console.error('Error fetching exchange rates:', error);
            }
        };

        const fetchParcelData = async (parcelId) => {
            const cleanId = parcelId.trim();
            try {
                const q = query(
                    collection(db, "parcels"),
                    where("id", "==", cleanId)
                );
                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    querySnapshot.forEach((doc) => {
                        const parcelData = doc.data();
                        const products = parcelData.products || [];
                        const totalUSD = products.reduce(
                            (acc, product) => acc + parseFloat(product.productPrice),
                            0
                        );

                        const totalKZT = totalUSD * usdToKztRate;
                        const insurance = totalKZT * 0.015;

                        const totalEUR = totalUSD * usdToEurRate;

                        let dutyEUR = 0;
                        let dutyKZT = 0;

                        if (totalEUR > 200) {
                            const excess = totalEUR - 200;
                            dutyEUR = excess * 0.15;
                            dutyKZT = dutyEUR * eurToKztRate;
                        }

                        // Установка состояний
                        setTotalCostUSD(totalUSD);
                        setTotalCostKZT(totalKZT);
                        setInsuranceAmount(insurance);
                        setCustomDutyEUR(dutyEUR);
                        setCustomDutyKZT(dutyKZT);
                    });
                }
            } catch (error) {
                // обработка ошибки
            }
        };


        if (id) {
            fetchExchangeRates();
            fetchParcelData(id);
        }
    }, [id, usdToKztRate, usdToEurRate]);


    return (
        <FormContainer>
            <StepRowContainer>
                {/* Шаг 4 */}
                <Step4Container>
                    <StepTitle active={true}>
                        <HighlightedText>Шаг 4. </HighlightedText>Страхование посылки
                    </StepTitle>
                    <StepContainer>
                        <BoldGreenText>
                            Сумма страхования - {Math.round(insuranceAmount)} ₸
                        </BoldGreenText>
                        <StepText>
                            В стоимость доставки включена обязательная страховка — 1,5% от объявленной стоимости товаров.
                        </StepText>
                    </StepContainer>
                </Step4Container>

                {/* Шаг 5 */}
                <Step5Container>
                    <StepTitle active={true}>
                        <HighlightedText>Шаг 5. </HighlightedText>Таможенный лимит
                    </StepTitle>
                    <StepContainer>

                        <StepText>Указанная сумма таможенной пошлины — {customDutyEUR.toFixed(2)} €
                            / {customDutyKZT.toFixed(2)} ₸ — является информационной и рассчитана на основе стоимости
                            товаров в посылке ({totalCostKZT.toFixed(2)} ₸) с превышением беспошлинного лимита в 200 €,
                            установленного законодательством РК.
                        </StepText>

                    </StepContainer>

                </Step5Container>
            </StepRowContainer>
        </FormContainer>

    );
};

export default Step4and5Step;
